import React, { useCallback, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system/values';
import { SettingsItem, SettingsItemRightContent, } from 'design-system/SettingsItem';
import IconSpace from 'design-system/icons/IconSpace';
import { SettingsItemIcon } from 'design-system/SettingsItemIcon';
import RadioButton from 'design-system/RadioButton';
import useColors from 'hooks/useColors';
import { Button } from 'design-system';
import { formatPlural } from 'utils';
const SpaceItem = ({ space, isSelected, selectedSpaceId, onSelect, onPress, }) => {
    const colors = useColors();
    const press = useCallback(() => {
        if (onPress) {
            onPress(space.id);
            return;
        }
        if (onSelect) {
            onSelect(space);
        }
    }, [onPress, onSelect, space]);
    const renderIcon = useMemo(() => {
        if (onSelect) {
            if (space.isDefault || space.isPremium) {
                return (<RadioButton isChecked={selectedSpaceId === space.id} type="single"/>);
            }
            return (<Button square hug small errorReversed title="Action required" onPress={press} style={styles.button}/>);
        }
        return null;
    }, [
        onSelect,
        press,
        selectedSpaceId,
        space.id,
        space.isDefault,
        space.isPremium,
    ]);
    return (<SettingsItem onPress={press} renderIcon={() => (<SettingsItemIcon style={styles.icon}>
          <IconSpace color={isSelected
                ? colors.gradients.ultimate.colors[0]
                : colors.text.secondary}/>
        </SettingsItemIcon>)} title={space.isDefault ? 'Private space' : space.name} description={`${space.accountsCount
            ? `${space.accountsCount} ${formatPlural(`account`, 'accounts', space.accountsCount)}`
            : '0 accounts'}${space.usersCount && !space.isDefault
            ? `${' • '}${space.usersCount} ${space.usersCount === 1 ? 'member' : 'members'}`
            : ''}`} descriptionProps={{ numberOfLines: 1 }} titleProps={{ numberOfLines: 2 }}>
      <SettingsItemRightContent>{renderIcon}</SettingsItemRightContent>
    </SettingsItem>);
};
const styles = StyleSheet.create({
    icon: {
        marginEnd: rem(16),
    },
    button: {
        marginLeft: rem(8),
    },
});
export default SpaceItem;
